import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
`;

export const HeaderIcon = styled.i`
  font-size: 29px;
  color: #ffffff;
`;

export const HeaderText = styled.span`
  font-size: 15px;
  color: #ffffff;
`;

export const CloseIconContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding: 0px 20px;
`;

export const CloseIcon = styled.div`
  font-size: 28px;
  color: #808080;
  cursor: pointer;
`;

export const PageTitleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;

  margin-top: -10px;
  padding: 0px 20px;
`;

export const PageIcon = styled.i`
  font-size: 40px;
  color: #808080;
`;

export const PageTitle = styled.span`
  color: #808080;
  font-size: 20px;
  font-weight: 300;
`;

export const PageContent = styled.span`
  color: #808080;
  font-size: 20px;
  font-weight: 300;
`;

export const BankSlipsContainer = styled.div`
  width: 100%;
  padding: 20px;
`;

export const DesktopWrapper = styled.div`
  width: 100vw;
  display: none;

  @media (min-width: 1100px) {
    display: initial;
  }
`;

export const MobileWrapper = styled.div`
  width: 100vw;
  display: none;

  @media (max-width: 1100px) {
    display: initial;
  }
`;

export const Content = styled.div`
  height: 95%;
  width: 100%;
  padding: 0 100px;

  @media (max-width: 1360px) {
    padding: 0 50px;
  }

  @media (max-width: 1220px) {
    padding: 0;
  }

  @media (max-width: 768px) {
    height: 100vh;
    width: 100%;
  }
`;

export const NextPage = styled.span`
  color: #000FFF;
  padding: 0.5rem;
  border-radius: 0.5rem;
  cursor: pointer;
`;

export const NextPageContainer = styled.div`
  display: flex;
  justify-content: ${(props) => props.content};
  margin-bottom: 1.5rem;
  color: #000FFF;
`;

export const PageTitleItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const FilterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
`;

export const FilterText = styled.span`
  color: #000FFF;
  font-size: 14px;
`;

export const FilterIcon = styled.img`
  width: 15px;
  height: auto;
  margin-right: 5px;
`;

export const DesktopHeaderContainer = styled.div`
  width: 100%;
  padding: 0 0 20px 20px;
  background-color: white;
  margin-bottom: 30px;
  @media (max-width: 770px) {
    padding: 0;
  }
`;

export const PageContainer = styled.div`
  height: 100vh;
  width: 100vw;
  padding: 0px;
  margin: 0px;
  background-color: #ffffff;
  overflow-y: none;
`;

export const HeaderMobile = styled.div`
  width: 100%;
  height: auto;
  display: none;
  align-items: center;
  justify-content: center;
  background-color: #000FFF;
  color: #ffffff;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  padding: 5px;
  margin-top: -30px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    display: flex;
  }
`;

export const HeaderContainer = styled.div`
  width: 100%;
  padding: 0 0 20px 20px;
  background-color: white;
  margin-bottom: 30px;
  @media (max-width: 770px) {
    padding: 0;
  }
`;

export const WrapperInvoices = styled.div`
  height: 89%;
  width: 100%;
  margin-top: -20px;
  overflow-y: scroll;

  @media (max-width: 770px) {
    margin-top: 0px;
  }
`;

export const InvoiceMessage = styled.div`
  display: flex;
  justify-content: center;
  margin: 1rem 0 0 0;

  span {
    color: #808080;
  }
`;
